// src/components/ComparisonTable.js
import "./ComparisonTable.css";

export default function ComparisonTable({ rows, rooms }) {
  // Support your older usage (rooms=[{aiWidth, aiLength, ...}]) AND the new rows format
  let resolvedRows = rows;

  if ((!resolvedRows || !resolvedRows.length) && Array.isArray(rooms) && rooms.length) {
    // Convert the first room entry into 2 rows (Width + Length)
    const r0 = rooms[0] || {};
    const aiW = Number.isFinite(r0.aiWidth) ? r0.aiWidth : null;
    const aiL = Number.isFinite(r0.aiLength) ? r0.aiLength : null;

    resolvedRows = [
      {
        label: "Width",
        user: null,
        ai: aiW,
        delta: aiW != null ? aiW : 0,
      },
      {
        label: "Length",
        user: null,
        ai: aiL,
        delta: aiL != null ? aiL : 0,
      },
    ].filter((x) => x.ai != null);
  }

  if (!resolvedRows?.length) return null;

  return (
    <div className="comparison-card">
      <h3 className="comparison-title">Measurement Comparison</h3>

      <table className="comparison-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>User (ft)</th>
            <th>AI (ft)</th>
            <th>Δ</th>
          </tr>
        </thead>

        <tbody>
          {resolvedRows.map((r, i) => {
            const delta = Number(r.delta ?? 0);
            const deltaClass = delta >= 0 ? "delta-pos" : "delta-neg";

            return (
              <tr key={i}>
                <td>{r.label ?? ""}</td>
                <td>{r.user ?? "—"}</td>
                <td>{Number.isFinite(r.ai) ? r.ai.toFixed(2) : "—"}</td>
                <td className={deltaClass}>{delta.toFixed(2)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
